import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import DashboardNav from './DashboardNav';

export default function DashboardLayout({ children }) {
  useEffect(() => {
    const appEl = document.querySelector('.App');
    const prev = {
      htmlOverflow: document.documentElement.style.overflow,
      htmlHeight:   document.documentElement.style.height,
      bodyOverflow: document.body.style.overflow,
      bodyHeight:   document.body.style.height,
      bodyPosition: document.body.style.position,
      appPosition:  appEl?.style.position,
      appOverflow:  appEl?.style.overflow,
      appHeight:    appEl?.style.height,
    };
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.height   = 'auto';
    document.body.style.overflow  = 'auto';
    document.body.style.height    = 'auto';
    document.body.style.position  = 'static';
    if (appEl) { appEl.style.position = 'static'; appEl.style.overflow = 'visible'; appEl.style.height = 'auto'; }
    return () => {
      document.documentElement.style.overflow = prev.htmlOverflow;
      document.documentElement.style.height   = prev.htmlHeight;
      document.body.style.overflow  = prev.bodyOverflow;
      document.body.style.height    = prev.bodyHeight;
      document.body.style.position  = prev.bodyPosition;
      if (appEl) { appEl.style.position = prev.appPosition; appEl.style.overflow = prev.appOverflow; appEl.style.height = prev.appHeight; }
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <DashboardNav />
      <Box sx={{ ml: '200px', flex: 1, minWidth: 0 }}>
        {children}
      </Box>
    </Box>
  );
}
